// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d65ffcc4","496":"3230c9af","498":"8817bf97","703":"5c711f1f"}[chunkId] + ".chunk.js";
};